export default {
  backgroundColor: "#fff",
  textStyle: {},
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: "#181C32",
      },
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#F2F2F4",
      },
    },
    axisTick: {
      show: true,
      alignWithLabel: true,
      lineStyle: {
        color: "#F2F2F4",
      },
    },
    axisLabel: {
      show: true,
      color: "#2c2c34",
    },
  },
  valueAxis: {
    splitLine: {
      show: true,
      lineStyle: {
        color: "#F2F2F4",
      },
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      show: true,
      color: "#2c2c34",
    },
  },
};
